import { render } from "./WikiExplorer.vue?vue&type=template&id=ec6bd27a&scoped=true"
import script from "./WikiExplorer.vue?vue&type=script&lang=js"
export * from "./WikiExplorer.vue?vue&type=script&lang=js"

import "./WikiExplorer.vue?vue&type=style&index=0&id=ec6bd27a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6bd27a"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QItem,QItemSection,QItemLabel,QChip,QIcon,QRating,QTooltip,QSeparator,QUploader,QExpansionItem,QCard,QCardSection,QBtn,QInnerLoading,QDialog});qInstall(script, 'directives', {ClosePopup});
